import { render, staticRenderFns } from "./ResetPasswordOk.vue?vue&type=template&id=2c744ace&"
import script from "./ResetPasswordOk.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports